import { render, staticRenderFns } from "./BillingData2.vue?vue&type=template&id=13b31ba5&scoped=true&"
import script from "./BillingData2.vue?vue&type=script&lang=js&"
export * from "./BillingData2.vue?vue&type=script&lang=js&"
import style0 from "./BillingData2.vue?vue&type=style&index=0&id=13b31ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b31ba5",
  null
  
)

export default component.exports